module.exports = __webpack_public_path__ + "img/products5.d5814e3b.jpg";